import{jsx as e,jsxs as t,Fragment as i}from"react/jsx-runtime";import{cloneElement as o}from"react";import r from"tailwind-styled-components";import c from"clsx";const n=r.div`
  overflow-y-auto
`,s=r.div`
  section-list__sticky-header
  bg-white
  clear-both
  items-center
  flex
  sticky
  top-0
  px-2
  py-1
  border-b
  border-gray-100
  z-10
`,l=r.div`
  item-container
  bg-white
  border-b
  border-gray-100
  flex
  items-center
  px-2
  py-2
`,m=r.div`
  flex
  flex-col
`,a=r.p`
  font-medium
`,d=r.small`
  text-sm
`,p=({item:i})=>{const r="object"==typeof i&&i.disabled,n=c("section-list__item",{"pointer-events-none opacity-50 grayscale":r});return t(l,{children:["string"==typeof i&&i,"object"==typeof i&&i.icon&&o(i.icon,{className:c(i.icon.props.className,"w-8 h-8 mr-3",n)}),"object"==typeof i&&t(m,{className:n,children:[e(a,{children:i.label}),i.description&&e(d,{children:i.description})]})]})},f=({title:e})=>t(i,{children:["string"==typeof e&&e,"object"==typeof e&&e.icon&&o(e.icon,{className:c(e.icon.props.className,"w-4 h-4 mr-2")}),"object"==typeof e&&e.label]}),y=t=>e(p,{item:t}),b=({renderSectionHeader:i=f,renderItem:o=y,onItemClick:r,sections:l,...m})=>{const a=e=>()=>{"function"==typeof r&&r(e)};return e(n,{...m,role:"list",children:l.map(((n,l)=>t("div",{children:[e(s,{children:i(n)}),e("div",{children:n.items.map(((t,i)=>e("div",{className:c("section-list__item-container",{"cursor-pointer":"function"==typeof r}),onClick:a(t),role:"listitem",children:o(t,n)},`${l}-${i}`)))})]},l)))})};b.Item=p;export{b as default};
